import Vue from "vue";
import Vuex from "vuex";
import EventBus from "@/events/event-bus.js";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    dashboardYear: "all",
    dashboardEmployeeType: "employee",
  },
  mutations: {
    updateUser(state, user) {
      state.user = user;
    },
    updateDashboardYear(state, year) {
      state.dashboardYear = year;
    },
    updateDashboardEmployeeType(state, employeeType) {
      state.dashboardEmployeeType = employeeType;
    }
  },
  actions: {
    updateUser({ commit, state }, user) {
      this.commit("updateUser", user);
    },
    updateDashboardYear({ commit, state }, year) {
      this.commit("updateDashboardYear", year);
      EventBus.$emit('dashboardYearChanged', year);
    },
    updateDashboardEmployeeType({ commit, state }, employeeType) {
      console.log(employeeType);
      this.commit("updateDashboardEmployeeType", employeeType);
      EventBus.$emit('dashboardEmployeeTypeChanged', employeeType);
    }
  },
  modules: {},
});
